<template>
    <div class="container">
      <div class="mianview">
          <div class="yudingbody">
              <span class="yudingbody_span1">基本信息</span>
              <div class="yudingbody_div">
                  <div class="yudingbody_div_left">
                    <span class="yudingbody_div_span1">*</span>
                    <span class="yudingbody_div_span2">姓名</span>
                  </div>
                  <input class="input" type="text" placeholder="请输入真实姓名" @blur="blur" v-model.trim="realName" maxlength='5' />
              </div>
              <div class="inputLine"></div>
              <div class="yudingbody_div">
                <div class="yudingbody_div_left">
                    <span class="yudingbody_div_span1">*</span>
                    <span class="yudingbody_div_span2">公司</span>
                  </div>
                  <input class="input" type="text" placeholder="请输入公司名称" @blur="blur" v-model.trim="companyName" maxlength="20" />
              </div>
              <!-- <div class="inputLine"></div> -->
          </div>
          <!-- <div class="kaipiaoDiv">
            <div class="kaipaioTop">
                <span class="kaipiaoTitle">是否开票</span>
                <div v-if="iskaipiao==0" class="unChoose" @click="chooseKaipiao(1)">
                  <div class="unChoose_dot"></div>
                </div>
                <div v-else class="Choose" @click="chooseKaipiao(0)">
                  <div class="Choose_dot"></div>
                </div>
            </div>
            <div class="kaipaoBody" v-if="iskaipiao==1">
               <div class="topItem">
                  <div class="topItemLeft">
                      <span class="topItemLeft_span1">*</span>
                      <span class="topItemLeft_span2">抬头类型</span>
                  </div>
                 <div class="topItemRight">
                     <div  v-if="receiptType !=2" class="selectItem_dot" @click="changeSelect(2)" ></div>
                     <img v-else class="selectItem_icon" :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
                     <span class="selectItem_span" >企业单位</span>
                     <div  v-if="receiptType ==2"  class="selectItem_dot" @click="changeSelect(1)"></div>
                     <img v-else class="selectItem_icon" :src="require(`../../assets/images/icon_check_${common.theme}.png`)"  />
                     <span class="selectItem_span">个人</span>
                 </div>
              </div>
              <div class="itemLine"></div>
              <div class="topItem">
                    <div class="topItemLeft">
                        <span class="topItemLeft_span1">*</span>
                        <span class="topItemLeft_span2">名称</span>
                    </div>
                    <div class="topItemRight">
                        <input @input="input" class="input" type="text" placeholder="填写发票抬头" @focus="focus" @blur="receiptblur" v-model.trim="receiptTitle" maxlength='30' />
                        <div v-if="isInInput &&receiptTitle" class="closeDiv">
                            <img @click="clear" class="closeImage" src="../../assets/images/btn_clear.png" />
                        </div>
                    </div>
              </div>
              <div class="itemLine"></div>
              <div class="topItem" v-if="receiptType ==2" >
                  <div class="topItemLeft">
                      <span class="topItemLeft_span1">*</span>
                      <span class="topItemLeft_span2">税号</span>
                  </div>
                  <div class="topItemRight">
                      <input class="input" type="text" placeholder="填写纳税人识别号" @blur="blur" v-model.trim="ratepayingNumber" maxlength='30' />

                  </div>
              </div>
              <div class="itemLine" v-if="receiptType ==2"></div>
              <div class="topItem" >
                 <span class="kaipiaoMsg">请仔细核对开票信息，以免影响您发票使用进度。</span>
              </div>

            </div>
            <div v-if="receiptType==2 && isInInput &&resultList.length>0" class="popView" >
                <scroll class="scroll" :pullup="false" :pulldown="false" >
                    <div class="scrollItem" v-for="(item,index) in resultList" :key="index" @click="chooseReceipt(item)">
                        <span class="scrollItem_span">{{item.enterpriseName}}</span>
                    </div>

                </scroll>
           </div>

          </div> -->


          <div v-if="valedataParams()" :class="['yuding_Button',$store.state.common.theme==3?'yuding_3':'']" @click="pushToroomPay()">
                  <span class="Button_span">确认</span>
          </div>
          <div v-else class="grayButton">
                  <span class="Button_span">确认</span>
          </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Scroll from "@/components/scroll";
import {receiptApisearchByName} from "@/utils/api";
export default {
  name: "yudingName",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
   components:{
        Scroll,
    },
  data() {
    return {
      realName:'',
      companyName:'',
      totalPrice:'',
      id:'',
      timeList:'',
      activeWeekDay:'',
      selectStart:'',
      selectEnd:'',
      activeDate:'',
      hourCount:'',
      activeCompanyObj:'',
      freePrice:'',
      iskaipiao:0, //是否开票
      receiptType:2,// 开票类型（整型）：1、个人/非企业单位；2、企业单位
      receiptTitle:'', // 开票名称
      isInInput:false,
      ratepayingNumber:'',// 纳税人识别号
      resultList:[]
    }
  },
  created () {
    let options = this.$route.query;
    this.selectDay = options.selectDay;
    this.activeWeekDay = options.activeWeekDay;
    this.timeList = JSON.parse(options.timeList);
    this.selectStart = options.selectStart;
    this.selectEnd = options.selectEnd;
    this.hour = options.hour;
    this.totalPrice = options.totalPrice / 1000;
    this.id = options.id;
    this.realName =
      this.common.userTenantInfo.userName ||
      this.common.userInfo.userName ||
      this.common.userInfo.name ||
      "";
     this.companyName= this.common.userTenantInfo.company || ""
     //'测试数据为什么会那么那么长简直是变态啊还是不够长怎么办呢要二十个字呢'
     //111
    // this.tel = this.common.userInfo.phone || this.common.userInfo.account;
    // 有用免额时长
    if (options.activeCompanyObj) {
      this.activeCompanyObj = JSON.parse(options.activeCompanyObj);
      this.freePrice = options.freePrice;
    }

  },
  methods: {
    focus(e){
        this.isInInput =true;
    },
    receiptblur(e){
       // this.isInInput =false;
    },
    input(e){
       var self =this;
       console.log(JSON.stringify(this.receiptTitle));
       this.isInInput =true;
      if(this.receiptType==2 && this.receiptTitle && this.receiptTitle.length>3){
            var  params = {
                  companyName:this.receiptTitle,
            }
            receiptApisearchByName(params).then(res => {
                    if(res.res.code=='10000' ) {
                        if(res.body!=undefined && res.body!=null) {
                            self.resultList = res.body;
                            console.log("ret.body === " + JSON.stringify(self.resultList));
                        }
                    }else {
                          //  self.resultList =[];
                    }
           })

      }else if(this.receiptType==2 && this.receiptTitle && this.receiptTitle.length<3){
                    self.resultList = [];
      }

    },

    blur(e) {
        setTimeout(function() {
            var scrollHeight =
            document.documentElement.scrollTop || document.body.scrollTop || 0;
            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        }, 100);
    },
    chooseKaipiao(index){
        this.iskaipiao=index;
        if(index ==0){
            this.receiptTitle ='';
            this.ratepayingNumber ='';
            this.resultList =[];
        }
    },
    changeSelect(index){
            console.log("in changeSelect")
            this.receiptType =index;
            this.receiptTitle ='';
            this.ratepayingNumber ='';
            this.resultList =[];
    },
    clear(){
             this.receiptTitle ='';
             this.ratepayingNumber ='';
             this.resultList =[];
    },

    chooseReceipt(item){
             this.receiptTitle =item.enterpriseName
             this.ratepayingNumber =item.regNo
             this.isInInput =false;
    },
    valedataParams(){
      if(!this.realName ){
        return false;
      }
      if(!this.companyName){
        return false;
      }
      if(this.iskaipiao==1){
        if(!this.receiptTitle ){
          return false;
        }
        if(this.receiptType ==2){
           if(!this.ratepayingNumber){
             return false;
           }
        }
      }

      return true;
    },

    pushToroomPay(){
        var urlstr='';
        if (this.activeCompanyObj) {
          urlstr = `/roomPay/?id=${this.id}&totalPrice=${this.totalPrice * 1000}&userName=${this.realName}&userCompanyName=${this.companyName}&timeList=${JSON.stringify(this.timeList)}&activeWeekDay=${this.activeWeekDay}&selectStart=${this.selectStart}&selectEnd=${this.selectEnd}&selectDay=${this.activeDate}&hour=${this.hour}&activeCompanyObj=${JSON.stringify(this.activeCompanyObj)}&freePrice=${this.freePrice}`
          if(this.iskaipiao==1){
            urlstr= urlstr +"&receiptType="+this.receiptType +"&receiptTitle="+this.receiptTitle;
            if(this.receiptType==2){
              urlstr =urlstr +"&ratepayingNumber=" +this.ratepayingNumber
            }
          }
         this.$router.push({
            path:urlstr
          })
      } else {
         urlstr = `/roomPay/?id=${this.id}&totalPrice=${this.totalPrice * 1000}&userName=${this.realName}&userCompanyName=${this.companyName}&timeList=${JSON.stringify(this.timeList)}&activeWeekDay=${this.activeWeekDay}&selectStart=${this.selectStart}&selectEnd=${this.selectEnd}&selectDay=${this.activeDate}&hour=${this.hour}`
         if(this.iskaipiao==1){
            urlstr= urlstr +"&receiptType="+this.receiptType +"&receiptTitle="+this.receiptTitle;
            if(this.receiptType==2){
              urlstr =urlstr +"&ratepayingNumber=" +this.ratepayingNumber
            }
          }
       this.$router.push({
          path: urlstr
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    width:100%;
    // height: 100vh;
    position: relative;
    background:#EEEEEE;
    .flex(column);
}
.mianview{
    width:100%;
    display: flex;
    flex-direction: column;
    margin-top: 0px;
}
.yudingbody{
    width:100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    .yudingbody_span1{
        // margin-top: 60px;
        height: 100px;
        margin-left: 28px;
        margin-bottom: 20px;
        height:56px;
        font-size:32px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:100px;

    }

    .yudingbody_div{
         width: 100%;
         height: 100px;
         display: flex;
        flex-direction: row;
        .yudingbody_div_left{
            flex-direction: row;
            width: 220px;
            height: 100px;
            align-items: center;
            display: flex;
            .yudingbody_div_span1{
                height:40px;
                margin-left: 28px;
                font-size:28px;
                font-weight:400;
                color:rgba(252,63,86,1);
                line-height:40px;
            }
            .yudingbody_div_span2{
                height:40px;
                font-size:28px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:40px;
            }
         }
         .input{
            display: flex;
            height:100px;
            // margin-left: 40px;
            // margin-top: 28px;
            width: 400px;
            font-size:32px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:100px;
            overflow:hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
        }
    }

    .inputLine{
        height: 2px;
        margin-left: 220px;
        width: 530px;
        background:rgba(234,234,234,1);

    }


}

.kaipiaoDiv{
    margin-top: 14px;
    width:100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    position: relative;

}
.popView{
    position: absolute;
    width: 100%;
    height: 336px;
    background-color: white;
    top: 310px;
    left: 0px;
}
.scroll{
    //  flex: 1;
     height: 226px;
     margin-bottom: 10px;
     flex-direction: column;
}
.scrollItem{
    margin-left: 220px;
    display: flex;
    width: 530px;
    padding-top: 20px;
    padding-bottom: 20px;
    flex-direction: row;
    align-items: center;
     border-bottom: 1px solid rgba(234,234,234,1);
}
.scrollItem_span{
    font-size:28px;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.kaipaioTop{
  width:100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  display: flex;

}
.kaipiaoTitle{
  margin-left: 28px;
  height:44px;
  font-size:32px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:44px;

}

.unChoose{
  margin-right: 28px;
  width:112px;
  height:56px;
  border-radius:28px;
  border:2px solid rgba(198,207,212,1);
  flex-direction: row;
  align-items: center;
}
.unChoose_dot{
  margin-left: 10px;
  margin-top: 10px;
  width:36px;
  height:36px;
  border-radius:18px;
  background:rgba(198,207,212,1);
}

.Choose{
  margin-right: 28px;
  width:112px;
  height:56px;
  border-radius:28px;
  border:2px solid #1740DA;
  flex-direction: row;
  align-items: center;
}
.Choose_dot{
  margin-left: 66px;
  margin-top: 10px;
  width:36px;
  height:36px;
  border-radius:18px;
  background:#1740DA;
}

.kaipaoBody{
   flex-direction: column;
   width:100%;
}

.grayButton{
      margin-left: 40px;
      margin-top: 60px;
      width: 89.33%;
      height: 76px;
      border-radius:4px;
      background:#DADADA;
      display: flex;
      justify-content: center;
      flex-direction: row;
      align-items: center;
      .Button_span{
            height:44px;
            font-size:32px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:44px;
      }

    }

.yuding_Button{
    margin-left: 40px;
    margin-top: 60px;
    width: 89.33%;
    height: 76px;
    border-radius:4px;
    background:#1740DA;
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    .Button_span{
            height:44px;
            font-size:32px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:44px;
    }

}
.yuding_3{
  background: #A1805D;
}


.topItem{
    width: 100%;
    height: 100px;
    flex-direction: row;
    display: flex;
}
.topItemLeft{
    width: 220px;
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.topItemLeft_span1{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(252,63,86,1);
    line-height:40px;
}
.topItemLeft_span2{
    margin-left: 4px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;
}
.topItemRight{
     height: 100px;
     width: 530px;
     display: flex;
     flex-direction: row;
     align-items: center;
}
.selectItem_dot{
    width:36px;
    border-radius: 100%;
    height:36px;
    border:2px solid rgba(218,218,218,1);
}
.selectItem_icon{
     width:36px;
    border-radius: 100%;
    height:36px;
}
.selectItem_span{
    margin-left: 12px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
    margin-right: 40px;
}
.itemLine{
    margin-left: 220px;
    height: 2px;
    width:530px;
    background:rgba(234,234,234,1);
}
.input{
     height: 44px;
     width: 400px;
     font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;

}
.kaipiaoMsg{
    margin-left: 28px;
    margin-top: 30px;
    height:36px;
    font-size:26px;
    font-weight:400;
    color:rgba(253,152,56,1);
    line-height:36px;
}
.closeDiv{
    height: 100px;
    width: 130px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.closeImage{
    width: 44px;
    height: 44px;
    margin-right: 28px;
}
.itemButton{
     margin-top: 60px;
     width: 100%;
     flex-direction: row;
      display: flex;
}

</style>